import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getSingleOnlineSettingList(params) {
  return request({
    url: URL.sys.singleOnlineSetting,
    method: 'get',
    params
  })
}

export function saveSingleOnlineSetting(data) {
  return request({
    url: URL.sys.singleOnlineSetting,
    method: 'post',
    data
  })
}

export function resetSingleOnlineSetting(data) {
  return request({
    url: URL.sys.singleOnlineSetting,
    method: 'put',
    data
  })
}
